import React, { useEffect } from 'react'
import PropTypes from 'prop-types'
import CloseButton from 'components/CloseButton'
import AddUserModalForm from 'components/AddUserModalForm'
import AddUserModalError from 'components/AddUserModalError'
import AddUserModalSummary from 'components/AddUserModalSummary'
import { AddUserModalContainer } from './AddUserModal.styles'
import CloseIcon from 'components/CloseIcon'

const AddUserModal = ({
  closeModal,
  error,
  isBulkOperationCompleted,
  addBulkUsersResponse,
  handleOpenAddUsersModal,
  isModalOpen,
  handleSubmitAddUsers,
  selectedSite,
}) => {
  useEffect(() => {
    if (addBulkUsersResponse && isBulkOperationCompleted) {
      handleOpenAddUsersModal()
    }
  }, [addBulkUsersResponse, isBulkOperationCompleted])
  return (
    <AddUserModalContainer
      data-testid="add-user-content-wrapper"
      isModalOpen={isModalOpen}
    >
      <CloseButton
        data-testid="close-add-user-modal-button"
        onClick={closeModal}
      >
        <CloseIcon />
      </CloseButton>
      {error && !error.response ? (
        <AddUserModalError error={error} onClose={closeModal} />
      ) : isBulkOperationCompleted ? (
        <AddUserModalSummary data={addBulkUsersResponse} onClose={closeModal} />
      ) : (
        <AddUserModalForm
          handleCloseAddUsersModal={closeModal}
          handleSubmitAddUsers={handleSubmitAddUsers}
          selectedSite={selectedSite}
        />
      )}
    </AddUserModalContainer>
  )
}

AddUserModal.propTypes = {
  applicableRoles: PropTypes.array,
  addBulkUsersResponse: PropTypes.object,
  closeModal: PropTypes.func,
  error: PropTypes.object,
  handleAddMultipleUsers: PropTypes.func,
  handleAddSingleUser: PropTypes.func,
  isBulkOperationCompleted: PropTypes.bool,
  isOpenModal: PropTypes.bool,
  license: PropTypes.object,
  productType: PropTypes.string,
  skuCode: PropTypes.string,
}

export default AddUserModal



// WEBPACK FOOTER //
// ./src/components/AddUserModal/AddUserModal.js